import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup, Grid, makeStyles, createStyles } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 97,
        },
    }),
);

export const NewConnectionBuildingTypesForm: FC = () => {
    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_BUILDING_TYPES>();

    const convertValue = (): string => {
        if (values.newConnectionBuildingTypes.value.existing) return "existing";
        if (values.newConnectionBuildingTypes.value.new) return "new";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Gebäudeart
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.newConnectionBuildingTypes.value = {
                                    existing: v.indexOf("existing") >= 0,
                                    new: v.indexOf("new") >= 0,
                                };
                            });
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={9} sm={12} md={12}>
                                <FormControlLabel
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    value="new"
                                    control={<Radio />}
                                    label="Neubau"
                                    error={values.newConnectionBuildingTypes.error !== null}
                                />
                                <FormControlLabel
                                    value="existing"
                                    control={<Radio />}
                                    label="Bestandsgebäude"
                                    error={values.newConnectionBuildingTypes.error !== null}
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
